import IndividualTable from "../../../IndividualTable";
import { sampleData } from "../../sampleData";

const Distance70 = () => {
  let winners = ["428"];
  return <IndividualTable matchType={"2"} gender="M" event="70" subTitle="Puta" data={sampleData} topRankCount="1" winners={winners} />;
};
export default Distance70;
